import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import renderIntervalDatePickerField from '../../../../shared/components/form/IntervalDatePicker';

const DateRange = ({ handleSubmit, t, icon, name, hasLabel }) => {
  function renderFields() {
    return(
      <Field
        name={name}
        component={renderIntervalDatePickerField}
        rangePicker
        icon = {icon}
      />
    );
  }

  return(
    <form className="form form--horizontal" onSubmit={handleSubmit}>
      {hasLabel &&
        <div className="form__form-group">
          <span className="form__form-group-label">{t('asset_events.timeline.date_range_title')}</span>
          <div className="form__form-group-field">
            {renderFields()}
          </div>
        </div>
      }
      {!hasLabel && renderFields()}
    </form>
  )
};

DateRange.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

export default reduxForm({
  form: 'date_range_form', // a unique identifier for this form
})(withTranslation('common')(DateRange));
